module.exports = __webpack_public_path__ + "img/notifications.d3e90d5b.svg";